import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=170a58fa"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports